import React, { useEffect, useState } from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { BoxWrapper, Modal } from 'components/Base';
import api from 'api';
import Icons from 'components/Icons';
import { linkColor, secondaryText } from 'utils/colors';

interface SystemUpdatesModalProps {
  isModalOpen: boolean;
  closeModal: () => void;
  setHasUnseenUpdates: (value: boolean) => void;
  releaseNotes: any;
}

const useStyles = makeStyles(() =>
  createStyles({
    modal: {
      width: '1000px',
      maxWidth: '90vw',
      padding: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '20px',
      maxHeight: '80vh',
      overflow: 'auto'
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem'
    }
  })
);

const SystemUpdatesModal = ({
  isModalOpen,
  closeModal,
  setHasUnseenUpdates,
  releaseNotes
}: SystemUpdatesModalProps) => {
  const classes = useStyles();

  const [selectedReleaseNote, setSelectedReleaseNote] = useState({} as any);
  const [displayReleaseNote, setDisplayReleaseNote] = useState(false);

  // Mark updates as seen when modal is opened
  useEffect(() => {
    if (isModalOpen) {
      api.markUpdatesAsSeen().then(() => {
        setHasUnseenUpdates(false); // Remove red dot
      });
    }
  }, [isModalOpen, setHasUnseenUpdates]);

  return (
    <Modal isOpen={isModalOpen} closeModalFunc={() => closeModal()}>
      <BoxWrapper title="System updates" closeModal={() => closeModal()}>
        <div className={classes.modal}>
          {!displayReleaseNote && releaseNotes.length > 0 && (
            <div className={classes.list}>
              {releaseNotes.map((releaseNote: any, index: number) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    columnGap: '60px'
                  }}
                >
                  <div>
                    <div style={{ fontWeight: 700 }}>{releaseNote.name}</div>
                    <div
                      style={{ color: secondaryText, whiteSpace: 'pre-wrap' }}
                    >
                      {releaseNote.description}
                    </div>
                  </div>
                  <div
                    onClick={() => {
                      setSelectedReleaseNote(releaseNotes[index]);
                      setDisplayReleaseNote(true);
                    }}
                    className="dashboardLink"
                  >
                    View
                  </div>
                </div>
              ))}
            </div>
          )}
          {displayReleaseNote && (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '20px'
              }}
            >
              <div
                className="dashboardLink"
                style={{
                  display: 'flex',
                  alignItems: 'center'
                }}
                onClick={() => {
                  setSelectedReleaseNote({});
                  setDisplayReleaseNote(false);
                }}
              >
                <Icons.BackArrow style={{ fill: linkColor }} />
                Back
              </div>
              <div>
                <div style={{ fontWeight: 700 }}>
                  {selectedReleaseNote.name}
                </div>
                <div style={{ color: secondaryText, whiteSpace: 'pre-wrap' }}>
                  {selectedReleaseNote.description}
                </div>
                <div style={{ marginTop: '2rem' }}>
                  <object
                    data={selectedReleaseNote.document_url}
                    type="application/pdf"
                    width="100%"
                    height="600px"
                  >
                    <p>
                      Download{' '}
                      <a href={selectedReleaseNote.document_url}>the PDF</a>.
                    </p>
                  </object>
                </div>
              </div>
            </div>
          )}
        </div>
      </BoxWrapper>
    </Modal>
  );
};

export default SystemUpdatesModal;
